/**
 * Presents the server-owned offer window without treating a client clock as
 * authority. The server still decides whether an accept is valid.
 */
export function offerTiming(request, now = Date.now()) {
    const expiresAt = request.offerExpiresAt ? Date.parse(request.offerExpiresAt) : NaN;
    if (Number.isFinite(expiresAt)) {
        const secondsLeft = Math.max(0, Math.ceil((expiresAt - now) / 1000));
        return {
            expired: secondsLeft === 0,
            label: secondsLeft === 0 ? 'Offer expired' : `Expires in ${secondsLeft}s`,
            secondsLeft
        };
    }
    const elapsedSeconds = Math.max(0, Math.floor((now - request.timestamp) / 1000));
    if (elapsedSeconds < 60) {
        return { expired: false, label: `Waiting ${elapsedSeconds}s` };
    }
    const elapsedMinutes = Math.floor(elapsedSeconds / 60);
    if (elapsedMinutes < 60) {
        return { expired: false, label: `Waiting ${elapsedMinutes}m` };
    }
    return { expired: false, label: `Waiting ${Math.floor(elapsedMinutes / 60)}h` };
}
